export const JOB_WAITING = 'waiting';
export const JOB_RUNNING = 'running';
export const JOB_ERROR = 'error';
export const JOB_COMPLETE = 'complete';
export const INITIAL_IMPORT_TASK = 'initialImport';



// WEBPACK FOOTER //
// ./src/utils/importJobs.constants.js